import { goldPrices } from "@/mocks/prices";

export default function PriceTicker() {
  const items = [...goldPrices, ...goldPrices];
  return (
    <div className="ticker-wrap overflow-hidden border-y border-secondary-800 bg-secondary-950">
      <div className="container-page flex h-11 items-center gap-3">
        <span className="hidden shrink-0 items-center gap-1.5 text-xs font-semibold text-primary-300 sm:flex">
          <i className="ri-pulse-line" />
          实时金价
        </span>
        <div className="flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker items-center gap-8">
            {items.map((price, idx) => (
              <span key={`${price.code}-${idx}`} className="flex items-center gap-2 whitespace-nowrap text-xs">
                <span className="text-background-300">{price.name}</span>
                <span className="font-semibold text-background-50">{price.price}</span>
                <span className={price.change >= 0 ? "text-accent-300" : "text-background-200"}>
                  <i
                    className={price.change >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line"}
                    aria-hidden="true"
                  />
                  {price.change >= 0 ? "+" : ""}
                  {price.change.toFixed(2)}%
                </span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}